import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const EMOJIS = ['👏', '❤️', '🔥', '😂', '👍', '🎉', '😮', '💯'];

const ReactionBar = ({ onReact, isLive }) => {
    if (!isLive) return null;

    return (
        <div className="flex items-center gap-2 p-2 bg-[#2e0510]/80 backdrop-blur-sm rounded-full border border-[#3d1a24]">
            {EMOJIS.map((emoji) => (
                <button
                    key={emoji}
                    onClick={() => onReact(emoji)}
                    className="w-10 h-10 flex items-center justify-center text-xl rounded-full hover:bg-[#3d1a24] hover:scale-125 transition-all duration-200 active:scale-90"
                >
                    {emoji}
                </button>
            ))}
        </div>
    );
};

const FloatingReaction = ({ emoji, id, onComplete }) => {
    return (
        <motion.div
            key={id}
            initial={{ opacity: 1, y: 0, x: Math.random() * 100 - 50 }}
            animate={{ opacity: 0, y: -200, x: Math.random() * 100 - 50 }}
            transition={{ duration: 2, ease: 'easeOut' }}
            onAnimationComplete={() => onComplete(id)}
            className="absolute bottom-20 left-1/2 text-4xl pointer-events-none"
            style={{ zIndex: 100 }}
        >
            {emoji}
        </motion.div>
    );
};

const ReactionOverlay = ({ reactions, onRemoveReaction }) => {
    return (
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
            <AnimatePresence>
                {reactions.map((reaction) => (
                    <FloatingReaction
                        key={reaction.id}
                        emoji={reaction.emoji}
                        id={reaction.id}
                        onComplete={onRemoveReaction}
                    />
                ))}
            </AnimatePresence>
        </div>
    );
};

export { ReactionBar, ReactionOverlay, EMOJIS };
